export default __webpack_public_path__ + "static/media/modely6.c3e12f7b.jfif";